/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Weight_TipInputs */

const en_us2_profile_editors_weight_tip = /** @type {(inputs: Profile_Editors_Weight_TipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In the morning, before eating and after the bathroom: that way one entry compares with the next.`)
};

const pt_br2_profile_editors_weight_tip = /** @type {(inputs: Profile_Editors_Weight_TipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De manhã, em jejum e depois de ir ao banheiro: assim um registro é comparável ao outro.`)
};

const es_419_profile_editors_weight_tip = /** @type {(inputs: Profile_Editors_Weight_TipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por la mañana, en ayunas y después de ir al baño: así un registro se puede comparar con el siguiente.`)
};

const pt_pt2_profile_editors_weight_tip = /** @type {(inputs: Profile_Editors_Weight_TipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De manhã, em jejum e depois de ir à casa de banho: assim um registo é comparável com o outro.`)
};

const fr_fr2_profile_editors_weight_tip = /** @type {(inputs: Profile_Editors_Weight_TipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le matin, à jeun et après être passé aux toilettes : ainsi chaque mesure est comparable à la suivante.`)
};

const de_de2_profile_editors_weight_tip = /** @type {(inputs: Profile_Editors_Weight_TipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Morgens, nüchtern und nach dem Toilettengang: So lässt sich ein Eintrag mit dem nächsten vergleichen.`)
};

const it_it2_profile_editors_weight_tip = /** @type {(inputs: Profile_Editors_Weight_TipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Al mattino, a digiuno e dopo il bagno: così ogni registrazione è confrontabile con la successiva.`)
};

/**
* | output |
* | --- |
* | "In the morning, before eating and after the bathroom: that way one entry compares with the next." |
*
* @param {Profile_Editors_Weight_TipInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_weight_tip = /** @type {((inputs?: Profile_Editors_Weight_TipInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Weight_TipInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_weight_tip(inputs)
	if (locale === "es-419") return es_419_profile_editors_weight_tip(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_weight_tip(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_weight_tip(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_weight_tip(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_weight_tip(inputs)
	return en_us2_profile_editors_weight_tip(inputs)
});
export { profile_editors_weight_tip as "profile-editors.weight_tip" }